import { render } from "./SmallFooter.vue?vue&type=template&id=576c8bf1&scoped=true"
const script = {}

import "./SmallFooter.vue?vue&type=style&index=0&id=576c8bf1&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576c8bf1"]])

export default __exports__